import React from "react";
import {getStore} from "../../reducers/cart_icon_reducer";
import {Provider} from "react-redux";
import OffersForSingleBlueprintImage from "./OffersForSingleBlueprintImage";

const OffersForSingleBlueprintImageWithProvider = (props) => {
  return (
    <Provider store={getStore(props)}>
      <OffersForSingleBlueprintImage {...props}/>
    </Provider>
  );
};

export default OffersForSingleBlueprintImageWithProvider;
